import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useCalendar } from './calendarContext';
import DateTimePreferencesLink from '../../../../../platform/util/DateTimePreferencesLink';
export default function CalendarSystemSelector({ timezone, showTimezone = true, onTimezoneSelect }) {
  const prefs = useCalendar();
  return <Stack spacing={0.5}>
    <DateTimePreferencesLink prefs={prefs} timezone={timezone} onTimezoneSelect={onTimezoneSelect} />
    {showTimezone && timezone && <Typography variant="caption">Times shown in {timezone.replaceAll('_', ' ')}</Typography>}
  </Stack>;
}
